export const formFieldBaseClass =
  'rounded-xl border border-[rgba(36,34,30,0.08)] bg-white text-fs-400 text-ink-700 placeholder:text-ink-400 outline-none transition-[background-color,border-color,box-shadow] duration-settle ease-precise'

export const formFieldFocusClass =
  'focus:bg-white focus:border-[rgba(61,59,54,0.18)] focus:ring-0 focus:shadow-[0_0_0_1px_rgba(61,59,54,0.16)]'

export const formFieldFocusVisibleClass =
  'focus-visible:outline-none focus-visible:bg-white focus-visible:border-[rgba(61,59,54,0.18)] focus-visible:ring-0 focus-visible:shadow-[0_0_0_1px_rgba(61,59,54,0.16)]'

export const formFieldFocusWithinClass =
  'focus-within:bg-white focus-within:border-[rgba(61,59,54,0.18)] focus-within:shadow-[0_0_0_1px_rgba(61,59,54,0.16)]'

export const formFieldOpenClass =
  'data-[state=open]:border-[rgba(61,59,54,0.18)] data-[state=open]:shadow-[0_0_0_1px_rgba(61,59,54,0.16)]'
